import { client, formatQueryParams } from 'util/sdk';

// eslint-disable-next-line import/prefer-default-export
export const load = ({ fspId, payerId, ...params }) =>
  client
    .fsps(fspId)
    .payers(payerId)
    .iavRequests.query(formatQueryParams(params));
